import videojs from "video.js";

const defaults = {
	innerText: '',
	direction: '' // forward || backward
};

videojs.registerComponent('BigControlsBubble', class extends videojs.getComponent('Component') {
	constructor(player, options) {
		super(player, videojs.mergeOptions(defaults, options));

		this.el().innerText = this.options_.innerText;
		this.addClass(`vjs-big-controls__bubble_${this.options_.direction}`);

		this.player().one('canplay', () => {
			this.show();
		});
	}

	active() {
		this.addClass('vjs-big-controls__bubble_active');
	}

	inactive() {
		this.removeClass('vjs-big-controls__bubble_active');
	}

	createEl() {
		return videojs.dom.createEl('div', { className: 'vjs-big-controls__bubble vjs-hidden' });
	}
});
